import { Button, Col, Modal, Row, Space, Typography, theme } from "antd";
import React from "react";
import CancelIcon from "../../assets/images/icon/cancelIcon.svg";
const { Title, Text } = Typography;

const { useToken } = theme;

const CancelModal = ({
  title,
  subTitle,
  open,
  onOk,
  confirmLoading,
  onCancel,
  confirmTxtBtn,
}) => {
  const { token } = useToken();

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      title={""}
      open={open}
      onOk={onOk}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      footer={false}
      width={400}
    >
      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "center", marginTop: 30 }}
      >
        <img src={CancelIcon} width={100} alt="Close Icon" />
      </Space>

      <Row justify="center">
        <Col span={24} align="center">
          <Title level={5}>{title}</Title>
        </Col>
        <Col span={24} align="center">
          <Text className="sub-title" style={{ fontSize: 12 }}>
            {subTitle}
          </Text>
        </Col>
      </Row>

      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "center", marginTop: 20 }}
      >
        <Button
          key="back"
          onClick={handleCancel}
          style={{ color: token.colorSecondary }}
        >
          ยกเลิก
        </Button>
        <Button
          key="back"
          onClick={onOk}
          style={{ backgroundColor: token.thPrimary, color: "white" }}
        >
          {confirmTxtBtn}
        </Button>
      </Space>
    </Modal>
  );
};

export default CancelModal;
